import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { IndustriesQueryProvider } from "__legacy/queries/industries/IndustriesQueryProvider";
import { Button, Input, Layout, notification, PageHeader, Popconfirm, Row, Space, Table, Tooltip } from "antd";
import { Fragment, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const deleteIndustryMutation = gql`
  mutation($id: ID!) {
    deleteIndustry(id: $id) {
      industry {
        id
        name
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const handleSearch = (value: string) => setSearchQuery(value.trim());

  const [execDelete] = useMutation(deleteIndustryMutation, {
    errorPolicy: "none",
    onError: (error) => {
      notification.error({
        message: error.message,
      });
    },
    onCompleted: ({ deleteIndustry: { industry } }) => {
      notification.success({
        message: `Industry "${industry.name}" deleted`,
      });
    },
    refetchQueries: ["IndustriesQuery"],
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (value: string, resource: any) => <NavLink to={resource.id}>{value}</NavLink>,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (value: string, resource: any) => <NavLink to={resource.id}>{value}</NavLink>,
    },
    {
      title: "Kind",
      dataIndex: "kind",
      render: (value: string, resource: any) => <NavLink to={resource.id}>{value}</NavLink>,
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string) => (
        <Row justify="end">
          <Space>
            <Tooltip title="Edit" placement="bottom">
              <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
            </Tooltip>
            <Popconfirm
              title="Are you sure?"
              icon={<QuestionCircleOutlined />}
              onConfirm={() => execDelete({ variables: { id } })}
            >
              <Tooltip title="Delete" placement="bottom">
                <Button danger icon={<DeleteOutlined />}></Button>
              </Tooltip>
            </Popconfirm>
          </Space>
        </Row>
      ),
    },
  ];

  return (
    <IndustriesQueryProvider variables={{ search: searchQuery }}>
      {({ industries }) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title="Industries"
            extra={
              <Fragment>
                <Input.Search
                  allowClear
                  placeholder="search"
                  onSearch={handleSearch}
                  defaultValue={searchQuery ?? ""}
                  style={{ width: 500 }}
                />
                <Button onClick={() => navigate("new")} type="primary">
                  <PlusOutlined />
                  New
                </Button>
              </Fragment>
            }
          />
          <Layout.Content className="content">
            <Table rowKey="id" columns={columns} dataSource={industries} pagination={false} />
          </Layout.Content>
        </Fragment>
      )}
    </IndustriesQueryProvider>
  );
};
